import { render } from "./create-campain-button.vue?vue&type=template&id=4cd6c5c8"
import script from "./create-campain-button.vue?vue&type=script&setup=true&lang=js"
export * from "./create-campain-button.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/modules/whatsapp/pages/campaigns/list/components/create-campain-button.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "4cd6c5c8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('4cd6c5c8', __exports__)) {
    console.log('reload')
    api.reload('4cd6c5c8', __exports__)
  }
  
  module.hot.accept("./create-campain-button.vue?vue&type=template&id=4cd6c5c8", () => {
    console.log('re-render')
    api.rerender('4cd6c5c8', render)
  })

}


export default __exports__